/* src/app/modules_v2/booking/locations/components/sections/location-media-section/location-media-section.component.css */
.section-container {
}
.w-100 {
  width: 100%;
}
.media-form {
  padding: 20px;
}
.media-form h6.fw-bold {
  color: #333;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}
.media-form .row.mb-4 {
  margin-bottom: 30px;
}
.media-block {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.media-preview {
  position: relative;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}
.media-preview:hover .media-overlay {
  opacity: 1;
}
.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}
.media-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: #fafafa;
  color: #999;
  padding: 40px;
}
.media-placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}
.media-placeholder p {
  margin: 0;
  font-size: 14px;
}
.media-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.logo-preview-container {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.logo-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.logo-placeholder {
  height: 200px;
}
.banner-preview-container {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-placeholder {
  height: 200px;
}
.carousel-counter {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  padding: 6px 12px;
  background: #f0f0f0;
  border-radius: 20px;
}
.carousel-counter.carousel-limit {
  background: #fff3cd;
  color: #856404;
}
.carousel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}
.carousel-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.carousel-image-container {
  position: relative;
  width: 100%;
  height: 200px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}
.carousel-image-container:hover .carousel-overlay {
  opacity: 1;
}
.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}
.carousel-item-info {
  text-align: center;
}
.carousel-item-number {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}
.carousel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: #fafafa;
  color: #999;
  padding: 60px 20px;
  text-align: center;
}
.carousel-empty mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  margin-bottom: 15px;
}
.carousel-empty p {
  margin: 5px 0;
  font-size: 14px;
}
.carousel-empty .text-muted {
  color: #999;
  font-size: 12px;
}
.alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 6px;
}
.alert-info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}
.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 768px) {
  .carousel-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }
  .carousel-image-container {
    height: 150px;
  }
  .banner-preview-container {
    height: 150px;
  }
  .media-actions {
    flex-direction: column;
  }
}
.image-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}
.order-field {
  width: 100px;
}
.empty-state-small {
  text-align: center;
  padding: 24px;
  color: #999;
}
.empty-state-small mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.3;
}
.mb-3 {
  margin-bottom: 16px;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.spinner {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}
.alert .btn-close {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
}
/*# sourceMappingURL=location-media-section.component.css.map */
